import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule as AngularCommonModule, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '../common';
import { ProductionPriceListComponent } from './pages/production-price-list/production-price-list.component';
//import { AuthGuardService } from '../authentication';

import { PriceListFormComponent } from './pages/price-list-form/price-list-form.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MsalGuard } from '@azure/msal-angular';

export const productionPriceListRoutes: Routes = [
    {
        path: 'production-price-list',
        canActivate: [MsalGuard],
        component: ProductionPriceListComponent
    },
    {   path: 'price-list-form',
        canActivate: [MsalGuard],
        component: PriceListFormComponent

    }
];

@NgModule({
    declarations: [ProductionPriceListComponent, PriceListFormComponent],
    providers: [DatePipe],
    imports: [
        CommonModule,
        AngularCommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatIconModule,
        MatButtonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatCheckbox
    ],
})
export class ProductionPriceListModule { }
